import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import { titleCodes, textCodes } from "../../template_codes/sarphosaung/footer_page_codes";

function Footer() {
    return (
        <footer class="footer p-10 py-14">
            <div>
                <p className="font-semibold text-xl">{titleCodes.footerTitle.title}</p>
                <p>{textCodes.footerText.text}</p>
            </div>
            <div>
                <span class="footer-title">{textCodes.hotline.text}</span>
                <div>
                    <p>Copyright © {(new Date().getFullYear())} {textCodes.copyText.text}</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;